<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/errorSet/list' }">错题集</el-breadcrumb-item>
            <el-breadcrumb-item>错题训练进行中...</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="main-table">
            <el-card class="box-card ">
                <div slot="header" class="clearfix d-flex flex-align-center flex-justify-between">
                    <div class="d-flex flex-column ">
                        <span class="header-title">错题训练</span>
                    </div>
                    <div>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="goBack()"
                            class="mg-lef20">返回</el-button>
                    </div>
                </div>
                <div class="d-flex flex-align-center flex-justify-between ht-100">
                    <div class="topic d-flex flex-column ">
                        <h2>{{ questionItem.questionTypeText }}题</h2>
                        <div class="topic-content flex-1">
                            <div class="topic-title fz22">
                                {{ questionItem.questionTopic }}（{{ questionItem.questionScore
                                }}分）
                            </div>
                            <div class="mg-tp10" v-if="questionItem.questionImg">
                                <img :src="questionItem.questionImg" style="max-width: 200px;" alt="" srcset="">
                            </div>

                            <div class="topic-option">
                                <template v-if="questionItem.questionType == 1">
                                    <el-radio-group v-model="questionItem.myAnswer" class="d-flex flex-column">
                                        <el-radio :label="key" class="mg-tp5 "
                                            v-for="(value, key) of questionItem.questionOption" :key="key">
                                            {{ key }}、{{ value }}
                                        </el-radio>
                                    </el-radio-group>
                                </template>

                                <template v-else-if="questionItem.questionType == 3">
                                    <el-radio-group v-model="questionItem.myAnswer">
                                        <el-radio-button :label="true">正确</el-radio-button>
                                        <el-radio-button :label="false">错误</el-radio-button>
                                    </el-radio-group>
                                </template>

                                <template v-else-if="questionItem.questionType == 2">
                                    <el-checkbox-group v-model="questionItem.myAnswer" class="d-flex flex-column">
                                        <el-checkbox class="mg-tp5 " v-for="(value, key) of questionItem.questionOption"
                                            :key="key" :label="key"> {{ key }}、{{ value
                                            }}</el-checkbox>
                                    </el-checkbox-group>
                                </template>
                            </div>
                        </div>

                        <div class="topic-answer"
                            v-if="questionItem.myAnswer != null && questionItem.questionAnswer != null">
                            <div>
                                我的答案：{{ getAnswer(questionItem)
                                }}
                            </div>
                            <div>
                                正确答案：
                                {{ getQuestionAnswer(questionItem)
                                }}

                            </div>
                        </div>
                        <div class="topic-btn d-flex flex-align-center flex-justify-between">
                            <el-button type="primary" :disabled="questionList[0] && !questionList[0].upSign"
                                @click="prevTopic()">上一题</el-button>
                            <div>
                                <el-button type="primary" :disabled="questionList[0] && !questionList[0].dnSign"
                                    @click="nextTopic()">下一题</el-button>
                                <el-button type="success" @click="confirmExercise()">确认</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import previewPapers from '@/components/previewPapers.vue';
import { mistakesPage, mistakesDetails, mistakesRemove } from '@/api/mistakes.js'
export default {
    components: {
        previewPapers
    },
    data () {
        return {
            topicDialog: {
                visible: false,
            },
            previewDialog: {
                isPreview: false,
                examId: '',
                visible: false
            },
            countDown: '00:00',
            formInline: {

            },
            questionList: [],
            questionItem: {
                "answerCorrect": false,//答案是否正确	
                "courseCategoryId": 0,//课程类别id	
                "courseCategoryName": "",//课程类别名称	
                "myAnswer": {},//	我的答案
                answer: null,
                "questionAnalysis": "",//题目解析
                "questionAnswer": {},//答案
                "questionCode": "",//	题目编码
                "questionId": 0,//	题目id
                "questionImg": "",//题目配图
                "questionLanguagePoint": "",//题目知识点
                "questionOption": {},//	题目选项
                "questionScore": 0,//题目分值
                "questionTopic": "",//题目
                "questionType": 0, //	题型:1-单选,2-多选,3-判断
                questionTypeText: '',
            },

            examId: '',
            examItem: {
                examName: '',
                examTimeLength: '',
            },
            examResult: {},
        }
    },
    created () {
        this.getExerciseList()
    },
    mounted () {
        let that = this;
    },

    methods: {

        getAnswer (item) {
            const jsonItem = JSON.parse(JSON.stringify(item))
            if (jsonItem.questionType == 2) {
                return typeof jsonItem.myAnswer == 'string' ? jsonItem.myAnswer : jsonItem.myAnswer.join()
            } else if (jsonItem.questionType == 3) {
                if (jsonItem.myAnswer !== null) {
                    return JSON.parse(jsonItem.myAnswer) ? '正确' : '错误'

                } else {
                    return '-'
                }
            } else {
                return jsonItem.myAnswer
            }
        },
        getQuestionAnswer (item) {
            if (item.questionType == 3) {
                if (item.questionAnswer !== null) {
                    return JSON.parse(item.questionAnswer) ? '正确' : '错误'
                } else {
                    return '-'
                }
            } else {
                return item.questionAnswer
            }
        },
        getParams () {
            this.setNowQuestionAnswer()
            const params = {
                "answerResList": this.questionList.map(el => {
                    if (el.questionType == 2 && el.myAnswer != null) {
                        el.myAnswer = el.myAnswer.split(',').sort().join()
                    }
                    return {
                        questionId: el.questionId,
                        myAnswer: el.myAnswer == null ? null : el.myAnswer
                    }
                }),
                "examId": this.examItem.examId
            }
            return params
        },
        setNowQuestionAnswer () {
            const nowParams = {
                questionId: this.questionItem.questionId,
                myAnswer: this.questionItem.myAnswer
            }
            if (this.questionItem.questionType == 2) {
                nowParams.myAnswer = nowParams.myAnswer.join(',')
            }
            this.questionList[0] = JSON.parse(JSON.stringify(this.questionItem));
            this.questionList[0].myAnswer = nowParams.myAnswer;
        },
        async getExerciseList (upOrDown = null) {
            const res = await mistakesPage({
                currentMistakesCollectionId: this.questionList[0] ? this.questionList[0].mistakesCollectionId : '',
                workoutSign: true,
                pageNum: 1,
                upOrDown,
                pageSize: 1,
            });
            this.questionList = res.data.records || [];
            if (this.questionList.length) {
                this.setItem()
            } else {
                this.goBack()
            }
        },
        setItem () {
            this.questionItem = JSON.parse(JSON.stringify(this.questionList[0])).question;
            if (this.questionItem.questionType == 2) {
                this.$set(this.questionItem, 'myAnswer', [])
            } else {
                this.$set(this.questionItem, 'myAnswer', '')
            }
            this.$forceUpdate()
        },
        //练习：选择答案后 就展示正确答案
        async confirmExercise () {
            if (this.questionItem.questionType == 2 && !this.questionItem.myAnswer.length ||
                this.questionItem.questionType == 3 && this.questionItem.myAnswer + '' == '' ||
                this.questionItem.questionType == 1 && this.questionItem.myAnswer == '') {
                this.$message.warning('请选择答案');
                return;
            }

            const res = await mistakesDetails(this.questionList[0].mistakesCollectionId)
            if (res.data) {
                this.$set(this.questionItem, 'questionAnswer', res.data.question.questionAnswer)
                if (!this.questionList[0].upSign && !this.questionList[0].dnSign) {
                    this.$message.success('所有题目已完成，请返回');
                    await mistakesRemove([this.questionList[0].mistakesCollectionId])

                }
            }
            this.$forceUpdate()
        },
        goBack () {

            this.$router.back(-1)
        },

        isAnswer () {
            if (this.questionItem.questionType === 2) {
                return this.questionItem.myAnswer.join() === this.questionItem.questionAnswer
            } else if (this.questionItem.questionType === 3) {
                return this.questionItem.myAnswer === JSON.parse(this.questionItem.questionAnswer)
            } else {
                return this.questionItem.myAnswer === this.questionItem.questionAnswer

            }
        },
        //下一题
        async nextTopic () {
            if (this.isAnswer()) {
                await mistakesRemove([this.questionList[0].mistakesCollectionId])
            }
            this.getExerciseList(false);
        },
        //上一题
        async prevTopic () {
            if (this.isAnswer()) {
                await mistakesRemove([this.questionList[0].mistakesCollectionId])
            }
            this.getExerciseList(true);
        },
    },
}
</script>

<style lang="scss" scoped>
.main-table {
    padding: 20px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.box-card {
    height: 100%;
    display: flex;
    flex-direction: column;

    .el-card__body {
        height: 100%;
        flex: 1;
    }
}

.topic {
    border: 1px solid #d8d8d8;
    width: 100%;
    height: 100%;
    padding: 15px;
    box-sizing: border-box;

    h2 {
        margin: 0;
    }
}

.overview {
    border: 1px solid #d8d8d8;
    width: 38%;
    height: 100%;
    padding: 15px;
    box-sizing: border-box;
    font-weight: bold;
    overflow: auto;
    overflow-x: hidden;
}

.header-title {
    font-size: 20px;
    font-weight: bold;
}

.topic-title {
    padding: 10px 0;
}

.topic-option {
    flex-basis: 0;
    overflow-y: auto;
    padding: 10px 0;
    box-sizing: border-box;
}

.tpoic-num {
    display: grid;
    grid-template-columns: repeat(6, 61px);
    grid-row-gap: 20px;
    grid-column-gap: 20px;
    // max-height: 500px;
    // overflow-y: auto;

    div {
        width: 61px;
        height: 61px;
        border: 1px solid #d8d8d8;
        box-sizing: border-box;
        line-height: 61px;
        text-align: center;
        font-weight: bold;
        font-size: 14px;

        &.active {
            background-color: rgba(128, 255, 255, 1);
        }
    }
}

.tpoic-status {
    width: 80%;
    justify-content: space-between;
    display: flex;
    align-items: center;

    div {
        width: 61px;
        height: 61px;
        border: 1px solid #d8d8d8;
        box-sizing: border-box;
        line-height: 61px;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        margin-left: 10px;

        &.active {
            background-color: rgba(128, 255, 255, 1);
        }
    }
}

.clearfix {
    width: 100%;
}

.topic-answer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 15px 10px;
    background: rgba(196, 196, 196, 0.16);
    border-radius: 10px;
    color: rgba(215, 0, 15, 0.75);
    font-size: 18px;
}

.topic-content {
    flex-basis: 0;
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/errorSet/train.vue